import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';

export const createPriceValidationOnBlurHandler =
    (
        name: string,
        value: string,
        onChange: (value: string) => void,
        setError: (error: string) => void,
        isRequired: boolean = true
    ) =>
    (e: InterstateOnChangeEvent<string>) => {
        const { value: inputValue } = e.target;

        if (setError) {
            if (!inputValue || inputValue.trim() === '') {
                if (isRequired) {
                    setError(`${name} is required`);
                } else {
                    setError('');
                }
            } else if (Number(inputValue) === 0) {
                setError('The value should be greater than 0.');
            } else {
                setError('');
            }
        }

        const formattedValue = inputValue ? `${Number(inputValue).toFixed(2)}` : '';
        setTimeout(() => onChange(formattedValue), 0);
    };
